import tippy from 'tippy.js';
import 'tippy.js/dist/themes/light.css';

tippy('.js-tippy', {
	trigger: "click",
	theme: "light",
	arrow: true,
	interactive: true,
	content(reference) {
	  return document.getElementById(reference.getAttribute('data-template'))
	}
})
tippy('.np-tooltip--base', {
    trigger: "click",
    theme: "light",
    arrow: true,
    interactive: true,
    content(reference) {
      return $(reference).siblings('.tooltip-question__body')[0]
    }
})



// WEBPACK FOOTER //
// ./frontend/components/tippy/tippy.js